var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-tooltip",class:[_vm.theme],style:({
    width: _vm.width
  }),attrs:{"role":"x-tooltip","tabindex":"0"},on:{"blur":_vm.onBlur}},[(_vm.title)?_c('div',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{ref:"arrow",staticClass:"x-tooltip-arrow",attrs:{"data-popper-arrow":_vm.options.placement}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }